import styled from "styled-components";

import { SWReactIcons } from "@similarweb/icons";

import type { ISerpTileProps } from "./SerpTile";
import { SerpTile } from "./SerpTile";

const SelectedSerpTileArrow = styled(SWReactIcons)`
    position: absolute;
    left: 104px;
`;

export const ActiveSerpTile = ({ serpFeature, isSelected, getSerpCountText, onTileClick }: ISerpTileProps) => (
    <div style={{ position: "relative" }}>
        <SerpTile
            serpFeature={serpFeature}
            isSelected={isSelected}
            getSerpCountText={getSerpCountText}
            onTileClick={onTileClick}
        />
        {isSelected ? (
            <SelectedSerpTileArrow
                iconName="arrow-blue-border"
                size={"sm"}
            />
        ) : null}
    </div>
);
